import state from './moduleCashBookState.js'
import mutations from './moduleCashBookMutations.js'
import actions from './moduleCashBookActions.js'
import getters from './moduleCashBookGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

